import React from 'react'
import { Row, Col } from 'react-bootstrap'
import EditorTabs from './EditorTabs'
import TemplateActions from '../templateManagement/TemplateActions'
import HtmlEditor from './HtmlEditor'
import CssEditor from './CssEditor'
import WysiwygEditor from './WysiwygEditor'
import { useEditor } from './useEditor'

const EditorContent = () => {
	const { activeTab } = useEditor()

	const renderContentEditor = () => <WysiwygEditor />

	const renderHtmlEditor = () => <HtmlEditor />

	const renderCssEditor = () => <CssEditor />

	const renderActiveContent = () => {
		switch (activeTab) {
			case 'content':
				return renderContentEditor()
			case 'html':
				return renderHtmlEditor()
			case 'css':
				return renderCssEditor()
			default:
				return renderContentEditor()
		}
	}

	return (
		<div className="editor-content-container">
			{/* Editor Tabs */}
			<Row>
				<Col md={12}>
					<EditorTabs />
				</Col>
			</Row>

			{/* Content Panel */}
			<Row>
				<Col md={12}>{renderActiveContent()}</Col>
			</Row>

			{/* Template Actions */}
			<Row style={{ marginTop: '20px' }}>
				<Col md={12}>
					<TemplateActions />
				</Col>
			</Row>
		</div>
	)
}

export default EditorContent
